import {
  DatePickerActions,
  DatePickerStateProps,
  SetBetTypeStatePayload,
} from './props';
import { GamingAggregatorId } from '@/models/gaming-aggregator/id';

const DEFAULT_END_DATE: Date = new Date();
const DEFAULT_START_DATE: Date = new Date();
DEFAULT_START_DATE.setDate(DEFAULT_END_DATE.getDate() - 90);

const initialState: DatePickerStateProps = {
  startDate: typeof window === 'undefined' ? null : DEFAULT_START_DATE,
  endDate: typeof window === 'undefined' ? null : DEFAULT_END_DATE,
  aggregatorId:
    typeof window === 'undefined' ? null : GamingAggregatorId.Starsoft,
};

export default function datePickerReducer(
  state: DatePickerStateProps = initialState,
  action: SetBetTypeStatePayload,
): DatePickerStateProps {
  switch (action.type) {
    case DatePickerActions.SetDateFilter:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      };
    case DatePickerActions.ResetDatePicker:
      return {
        ...state,
        startDate: typeof window === 'undefined' ? null : DEFAULT_START_DATE,
        endDate: typeof window === 'undefined' ? null : DEFAULT_END_DATE,
      };
    case DatePickerActions.SetBetType:
      return {
        ...state,
        aggregatorId: action.payload,
      };
    default:
      return state;
  }
}
